import * as graphqlClient from './client'

export default graphqlClient
